import { GridContainer, GridItem, GridRow } from "@tvg/fuse/grid";
import Breadcrumb from "client/components/Breadcrumb";
import DynamicHeading from "client/components/DynamicHeading";
import { SEOConfig, SEOConfigProvider } from "client/context/SEOContext";
import React from "react";

export interface SEOHeadingProps extends SEOConfig {
  path: string;
  unfilteredFacet?: string | undefined;
}

const SEOHeading = (props: SEOHeadingProps) => {
  return (
    <SEOConfigProvider
      value={{ overrides: props.overrides, fallback: props.fallback }}
      initPath={props.path}
      unfilteredFacet={props.unfilteredFacet}
    >
      <GridContainer className="product-listing__accordion-container container">
        <Breadcrumb />
        <GridRow className="row product-listing__accordion">
          <GridItem xxs={12} l={12} className="grid-item">
            <DynamicHeading />
          </GridItem>
        </GridRow>
      </GridContainer>
    </SEOConfigProvider>
  );
};

export default React.memo(SEOHeading);
